import React, { useMemo } from 'react';
import { Skeleton } from 'antd';
import { isEmpty } from 'lodash';
import { StyledCard } from './styled';
import { AlertDescription } from './componentUtils';
import { formatAlertSummary } from './hooks/utils';
import useSetAIAlertExport from '@components/alert-panel/AIAlert/hooks/useSetAIAlertExport';
import { usePageTitle } from '@src/hooks';

function AlertInfo({ alert }) {

  useSetAIAlertExport();

  const info = useMemo(() => {
    if (alert) {
      return formatAlertSummary(alert);
    }
    return {};
  }, [alert]);

  usePageTitle({ text: info ? `Alert - ${info.rootCause}` : 'Alert...' });

  if (isEmpty(info)) {
    return (
      <StyledCard bordered={false} >
        <Skeleton />
      </StyledCard>
    );
  }

  return <AlertDescription info={info} />;
}

export default AlertInfo;
